import { TableChartOptions, StablecoinDO } from './table.models';

export enum TableChartType {
  STABLECOIN_TABLE = 'stablecoin-table',
}

export const stablecoinTableOptions: TableChartOptions<StablecoinDO> = {
  columns: [
    { key: 'stablecoin_name', label: 'Stablecoin' },
    { key: 'market_cap', label: 'Market Cap (USD)', render: v => Number(v).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }) },
    { key: 'domiciliation', label: 'Domiciliation' },
    { key: 'juridiction_name', label: 'Jurisdiction' },
    { key: 'regulatory_framework', label: 'Regulatory Framework' },
    { key: 'market_share', label: 'Market Share (%)', render: v => v ? v.toFixed(2) + '%' : '' },
  ]
}; 